import { fetchRetry } from '@/utils/api/fetchRetry';

export async function getTournaments() {
  try {
    const { data } = await fetchRetry({
      // prod
      // https://kefloixzy1.execute-api.us-west-2.amazonaws.com/prod/tournaments
      // dev
      // https://ura1k1h58a.execute-api.us-east-2.amazonaws.com/dev/tournaments
      url: 'https://kefloixzy1.execute-api.us-west-2.amazonaws.com/prod/tournaments',
      // url: 'https://ura1k1h58a.execute-api.us-east-2.amazonaws.com/dev/tournaments',
    });
    return data;
  } catch (e) {
    throw new Error(e);
  }
}

export async function fetchTournaments() {
  try {
    const response = await fetchRetry({
      url: 'https://17zyhpyc7c.execute-api.us-west-2.amazonaws.com/prod/tournaments',
    });
    return response && response.data ? response.data : [];
  } catch (e) {
    throw new Error(e);
  }
}

export async function fetchRightBetTournaments() {
  try {
    // https://wiy8vumyh2.execute-api.us-east-2.amazonaws.com/qa/tournaments-right-bet
    const response = await fetchRetry({
      url: 'https://cd2rabrly8.execute-api.us-east-2.amazonaws.com/prod/tournaments-right-bet',
    });
    return response && response.data ? response.data : [];
  } catch (e) {
    throw new Error(e);
  }
}
